import { injectGlobal } from 'styled-components';

injectGlobal`
    body {
        height: 100vh;
        overflow-y: scroll;
        overflow-x: hidden;
    }
`;


// WEBPACK FOOTER //
// ./src/components/global/global-settings/scroll-styles.js